import { render } from "./discount.vue?vue&type=template&id=a85a3ef4&scoped=true"
const script = {}

import "./discount.vue?vue&type=style&index=0&id=a85a3ef4&lang=scss&scoped=true"

import exportComponent from "D:\\wwwroot\\yunchi\\yc-vue-source\\yunman\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a85a3ef4"]])

export default __exports__